module.exports = __webpack_public_path__ + "static/media/CSRLogo.38d56a9a.png";